export const webClientType = 'web'
export const touchClientType = 'touch'
export const DEVICE_STORAGE_KEY = 'mamba-device-id'
